// Images
// Reference them with the image_tag helper in views (e.g < %= image_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
// const images = require.context('./images', true);
// const imagePath = (name) => images(name, true);

// Stylesheets
//import './styles/niiwin.scss'

// NPM libs
// NOTE: We expose some libs, e.g., jquery and moment via expose-loader
import 'bootstrap'
import jQuery from 'jquery'
import 'trix'
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker'
import 'form-request-submit-polyfill'
import 'regenerator-runtime/runtime'
import '@fortawesome/fontawesome-free/js/all'
import 'tom-select/dist/js/tom-select.complete.js'
import ContentLoader from '@stimulus-components/content-loader'

// React components
import './javascript/components/ColorPicker.jsx'
import './javascript/components/GeoLocation.jsx'
// Replaced the react index table with a hotwired version, so this is not needed
import './javascript/components/ni_ar_instances/index/IndexContainer.jsx'

// Stimulus controllers
import BootstrapPopoverController from './javascript/controllers/bootstrap/popover_controller'
import FormsAutoExpandTextareaController from './javascript/controllers/forms/auto_expand_textarea_controller'
import FormsConnectedSelectsController from './javascript/controllers/forms/connected_selects_controller'
import FormsDynamicArrayValuesController from './javascript/controllers/forms/dynamic_array_values_controller'
import FormsNestedAttrsController from './javascript/controllers/forms/nested_attrs_controller'
import FormsNestedTypedAttrsController from './javascript/controllers/forms/nested_typed_attrs_controller'
import FormsSelectController from './javascript/controllers/forms/select_controller'
import GeoLocationController from './javascript/controllers/attributes/geo_location.js'
import GeoLocationEditorController from './javascript/controllers/forms/geo_location_editor.js'
import NiappstructureGraphvizController from './javascript/controllers/niappstructure/graphviz_controller'

jQuery.fn.datepicker.defaults.format = 'yyyy-mm-dd'

// For New Table view
// Move to appropriate module when structure is formalized.
// When range type (and eventually other types with html attributes)
// is picked, we want to ask for min, max, step values.
// This handler shows and hides these options.
jQuery(document).on('turbo:load', function () {
  window.$ = jQuery
  jQuery('body').on('change', 'select.single', function () {
    const $parent = jQuery(this).parent()
    $parent
      .siblings('.multiple')
      .find('select.multiple option:selected')
      .prop('selected', false)
    const $el = $parent.siblings('.range-attrs')
    if (jQuery(this).val() === 'input_type_range') {
      $el.removeClass('d-none')
    } else {
      $el.addClass('d-none')
    }
  })

  jQuery('body').on('change', 'select.multiple', function () {
    const $parent = jQuery(this).parent()
    const $singleSelect = $parent.siblings('.single')
    $singleSelect.find('select option:selected').prop('selected', false)

    const $attrs = $parent.siblings('.range-attrs')
    $attrs.find('input').val(null)
    $attrs.addClass('d-none')
  })
})

// Convenience method to register all included controllers
// @param application [Stimulus.start] the application object to register controllers with.
const registerNiiwinControllers = (application) => {
  application.register('attributes--geo-location', GeoLocationController)
  application.register('bootstrap--popover', BootstrapPopoverController)
  application.register('content-loader', ContentLoader)
  application.register('forms--auto-expand-text-area', FormsAutoExpandTextareaController)
  application.register('forms--connected-selects', FormsConnectedSelectsController)
  application.register('forms--dynamic-array-values', FormsDynamicArrayValuesController)
  application.register('forms--geo-location-editor', GeoLocationEditorController)
  application.register('forms--nested-attrs', FormsNestedAttrsController)
  application.register('forms--nested-typed-attrs', FormsNestedTypedAttrsController)
  application.register('forms--select', FormsSelectController)
  application.register('niappstructure--graphviz', NiappstructureGraphvizController)
}

export {
  registerNiiwinControllers,
  BootstrapPopoverController,
  ContentLoader,
  FormsAutoExpandTextareaController,
  FormsConnectedSelectsController,
  FormsDynamicArrayValuesController,
  FormsNestedAttrsController,
  FormsNestedTypedAttrsController,
  FormsSelectController,
  GeoLocationController,
  GeoLocationEditorController,
  NiappstructureGraphvizController
}
